module.exports = __webpack_public_path__ + "static/img/sa.4dfb01ca.svg";